export default __webpack_public_path__ + "static/media/right-arrow.f21c8f78.svg";